import PropTypes from "prop-types";
import React from "react";

import SendHelpForm from "v2/components/responsive/SendHelpForm";
import ModalLink from "v2/components/responsive/ModalLink";

const SendHelpLink = (props, context) => {
  const {params: {date, routeId, id}} = context;
  return (
    <ModalLink
      form={SendHelpForm}
      label="Send Help"
      url={`/${date}/${routeId}/${id}/help`}
      {...props} />
  );
};

SendHelpLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }),
};

export default SendHelpLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/SendHelpLink.js
 **/